import booksData from '@/mockData/books.json'

const state = {
    books: booksData,
}

const mutations = {
    ADD_BOOK(state, payload) {
        state.books.push(payload)
    },
    TAKE_BOOK(state, payload) {
        let idx = state.books.findIndex(item => item.id === payload.id)
        state.books[idx].status = ` ${payload.currentUser}`
    },
    RETURN_BOOK(state, id) {
        let idx = state.books.findIndex(item => item.id === id)
        state.books[idx].status = 'free'
    },
}

const actions = {
    addBook({ commit }, form) {
        commit('ADD_BOOK', form)
    },
    takeBook({ commit }, payload) {
        commit('TAKE_BOOK', payload)
    },
    returnBook({ commit }, id) {
        commit('RETURN_BOOK', id)
    },
}

const getters = {
    getData: state => state.books
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
